<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row md-8 m-1">

        <p class="color">
          This schedule has some subjects assigned </br> Are you sure you want to
          override?
        </p>
      </div>

      <div class="col-md-12  mt-3 text-right">
        <slot name="action-button"></slot>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'Form',
  props: ['validate'],
  data() {
    return {
      loading: false,
      errors: new Errors()
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style lang="scss" scoped>
.color {
  text-align: center;
}
</style>
